import { createContext, useContext } from 'react';

import { ListDetailsAngular } from '../domain';

type AngularListSegmentContext = {
  listDetails?: ListDetailsAngular;
};

export const AngularListSegmentContext = createContext<AngularListSegmentContext>({});

export const useAngularListSegmentContext = () => useContext(AngularListSegmentContext);
